module.exports = __webpack_public_path__ + "img/location.071d49c7.svg";